import script from "./depositAuthDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./depositAuthDetail.vue?vue&type=script&setup=true&lang=js"

import "./depositAuthDetail.vue?vue&type=style&index=0&id=9e8a31dc&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e8a31dc"]])

export default __exports__